export default "__VITE_ASSET__DFnFXOat__"